import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../unidriver';
import { ExpandCollapseButtonUniDriver } from './ExpandCollapseButton.uni.driver';

export function NestedTableParentCellUniDriver(
  base: UniDriver,
  body: UniDriver,
) {
  const getWrapper = () => base.$('[data-hook="indention-wrapper"]');

  return {
    ...baseUniDriverFactory(base),
    getTitle: () => getWrapper().$('[data-hook="title"]').text(),
    getSubtitle: () => getWrapper().$('[data-hook="subtitle"]').text(),
    getExpandCollapseButton: () =>
      ExpandCollapseButtonUniDriver(
        getWrapper().$('[data-hook="expand-collapse-wrapper"]'),
        body,
      ),
  };
}
